import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem, InputAdornment, Divider } from '@mui/material';
import { AccountBalance, Send } from '@mui/icons-material';

const TransferTEDPage: React.FC = () => {
  const [formData, setFormData] = useState({
    bankCode: '',
    agency: '',
    account: '',
    accountDigit: '',
    accountType: 'checking',
    beneficiaryName: '',
    beneficiaryDocument: '',
    amount: '',
    description: '',
  });

  const handleChange = (field: string) => (e: any) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('TED:', formData);
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <AccountBalance sx={{ mr: 1, verticalAlign: 'middle' }} />
        Transferência TED
      </Typography>

      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Dados Bancários do Destinatário
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Código do Banco"
                value={formData.bankCode}
                onChange={handleChange('bankCode')}
                placeholder="Ex: 001"
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Agência"
                value={formData.agency}
                onChange={handleChange('agency')}
                required
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField
                fullWidth
                label="Conta"
                value={formData.account}
                onChange={handleChange('account')}
                required
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField
                fullWidth
                label="Dígito"
                value={formData.accountDigit}
                onChange={handleChange('accountDigit')}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Conta</InputLabel>
                <Select
                  value={formData.accountType}
                  label="Tipo de Conta"
                  onChange={handleChange('accountType')}
                >
                  <MenuItem value="checking">Conta Corrente</MenuItem>
                  <MenuItem value="savings">Poupança</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Dados do Beneficiário
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nome Completo"
                value={formData.beneficiaryName}
                onChange={handleChange('beneficiaryName')}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="CPF/CNPJ"
                value={formData.beneficiaryDocument}
                onChange={handleChange('beneficiaryDocument')}
                required
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Valor da Transferência
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Valor"
                value={formData.amount}
                onChange={handleChange('amount')}
                InputProps={{
                  startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descrição (opcional)"
                value={formData.description}
                onChange={handleChange('description')}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                startIcon={<Send />}
              >
                Realizar TED
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default TransferTEDPage;
